var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Sun",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10093",
    "data-name": "Path 10093",
    d: "M14.826,9.14a5.689,5.689,0,1,0,5.681,5.689A5.689,5.689,0,0,0,14.826,9.14Zm0,9.946a4.265,4.265,0,1,1,4.257-4.257A4.265,4.265,0,0,1,14.826,19.086Z",
    transform: "translate(-2.323 -2.325)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10094",
    "data-name": "Path 10094",
    d: "M16.526,5.606a.746.746,0,0,0,.708-.746V1.341a.746.746,0,0,0-1.424,0V4.9A.746.746,0,0,0,16.526,5.606Z",
    transform: "translate(-4.022 -0.208)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10095",
    "data-name": "Path 10095",
    d: "M16.516,26.29A.746.746,0,0,0,15.77,27v3.549a.746.746,0,0,0,1.424,0V27A.746.746,0,0,0,16.516,26.29Z",
    transform: "translate(-4.012 -6.688)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10096",
    "data-name": "Path 10096",
    d: "M30.61,15.81H27.061a.746.746,0,0,0,0,1.424H30.61a.746.746,0,0,0,0-1.424Z",
    transform: "translate(-6.751 -4.022)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10097",
    "data-name": "Path 10097",
    d: "M5.606,16.516a.746.746,0,0,0-.746-.746H1.341a.746.746,0,0,0,0,1.424H4.9A.746.746,0,0,0,5.606,16.516Z",
    transform: "translate(-0.208 -4.012)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10098",
    "data-name": "Path 10098",
    d: "M23.933,8.9a.7.7,0,0,0,.507-.209L26.953,6.18a.746.746,0,1,0-1.007-1.007L23.433,7.686a.746.746,0,0,0,0,1.007.7.7,0,0,0,.5.209Z",
    transform: "translate(-5.912 -1.215)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10099",
    "data-name": "Path 10099",
    d: "M7.756,23.359,5.243,25.871a.714.714,0,0,0,1.014,1.007L8.74,24.365a.746.746,0,1,0-.984-1.007Z",
    transform: "translate(-1.284 -5.837)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10100",
    "data-name": "Path 10100",
    d: "M24.477,23.471a.746.746,0,0,0-1.007,1.007l2.513,2.513a.712.712,0,1,0,1.007-1.007Z",
    transform: "translate(-5.949 -5.949)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10101",
    "data-name": "Path 10101",
    d: "M7.686,8.671a.7.7,0,0,0,.984-1.007L6.18,5.174A.746.746,0,1,0,5.174,6.18Z",
    transform: "translate(-1.215 -1.215)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 25,
    height: 25,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/Sun.785a5cb6e7cdf743ce117f1566673e82.svg";
export { ForwardRef as ReactComponent };